import { useConfirmation } from '@components/modal';
import { useDeleteGraphMutation } from '@generated/graphql';
import { MenuItem } from '@mui/material';
import { useOrganizationContext } from '@navigation/OrganizationContext';
import { useNotifications } from '@notifications/Notifications';
import { navigate } from 'gatsby';
import { MouseEvent } from 'react';

type GraphsListViewPreviewMenuDeleteConfigButtonProps = {
  graphId: string;
  name: string;
  workspaceId: string;
  refetch: () => void;
  onClose: () => void;
};

export const GraphsListViewPreviewMenuDeleteConfigButton = ({
  graphId,
  name,
  workspaceId,
  refetch,
  onClose,
}: GraphsListViewPreviewMenuDeleteConfigButtonProps) => {
  const { createAsyncNotification } = useNotifications();
  const { organizationId } = useOrganizationContext();
  const { showConfirmation } = useConfirmation({
    onAffirm: createAsyncNotification('Successfully deleted graph.', async () => {
      await deleteGraph();
      refetch();
      navigate(`/${organizationId}/workspaces/${workspaceId}/graphs/`);
    }),
    message: `Are you sure you want to delete ${name ? `${name} ` : ''}graph?`,
    onReject: onClose,
  });

  const [deleteGraph] = useDeleteGraphMutation({ variables: { workspaceId, graphId } });
  const handleDeleteConfigClick = (event: MouseEvent) => {
    event.stopPropagation();
    onClose();
    showConfirmation();
  };

  return (
    <MenuItem data-cy="Graph-Header-Dropdown-Delete" onClick={handleDeleteConfigClick}>
      Delete
    </MenuItem>
  );
};
